import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=51cccbaa&scoped=true&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"
import style0 from "./Error.vue?vue&type=style&index=0&id=51cccbaa&prod&lang=css&"
import style1 from "./Error.vue?vue&type=style&index=1&id=51cccbaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cccbaa",
  null
  
)

export default component.exports